<script setup lang="ts">
import type { LocationApiSearchResult } from '@@/shared/location/types';
import type { PropertySearchCriteria } from '@@/shared/property/search-criteria';

const modelValue = defineModel<PropertySearchCriteria['locations']>({ required: true });

// Updated locations
const { data: locationsFromSelectedSlug } = useLocationFromSlugs(modelValue);

const selectedLocations = computed(() => locationsFromSelectedSlug.value?.items ?? []);
function onRemoveLocation(location: LocationApiSearchResult) {
  modelValue.value = modelValue.value.filter(slug => slug !== location.slug);
}
function onLocationSelect(location?: LocationApiSearchResult) {
  if (!location) return;
  if (modelValue.value.includes(location.slug)) return;
  modelValue.value = modelValue.value.concat([location.slug]);
}
</script>

<template>
  <div>
    <IadInputLocation
      :hint="$t(`core.location.input_hint`)"
      :placeholder="$t(`core.location.input_placeholder`)"
      @update:model-value="onLocationSelect"
    />
    <ol

      class="flex flex-wrap gap-xs"
      :class="{
        'pt-s': modelValue.length > 0,
      }"
    >
      <li
        v-for="location in selectedLocations"
        :key="location.slug"
        class="inline-flex items-center gap-2xs border border-neutral-30 bg-secondary-70 rounded-lg px-s py-2xs hover:underline decoration-1 active:bg-primary-40 active:text-white whitespace-nowrap cursor-pointer"
        @click="onRemoveLocation(location)"
      >
        <span v-text="location.displayName" />
        <span
          class="empty:hidden"
          v-text="location.displayCode"
        />
        <Icon name="iad-icon:close" />
      </li>
    </ol>
  </div>
</template>
